function ArrowIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 10L25 20.5L16 31" stroke="white" strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default ArrowIcon;
